export default __webpack_public_path__ + "static/media/REMERAYOGUI1.edf79037.jpg";